import { render, staticRenderFns } from "./SentimentZhaban.vue?vue&type=template&id=18461ebc&scoped=true"
import script from "./SentimentZhaban.vue?vue&type=script&lang=js"
export * from "./SentimentZhaban.vue?vue&type=script&lang=js"
import style0 from "./SentimentZhaban.vue?vue&type=style&index=0&id=18461ebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18461ebc",
  null
  
)

export default component.exports